// import { fetchShows } from "./showActions";
// import { reloadProducts } from "./productsActions";
// import { setCookie } from "../helpers/cookie";

export const changeLanguage = (language) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_LANGUAGE',
      language,
    });

    // Fetch shows in new language
    // dispatch(fetchShows(language, getState().associates.jwt));
  };
};

export const changeCurrency = (currency) => {
  return {
    type: 'CHANGE_CURRENCY',
    payload: currency,
  };
};
